module.exports = __webpack_public_path__ + "static/media/5-3.ddd7e83b.mp3";